import signalVisitedUrlEventTriggersCRUDActions from 'packages/state/actions/SignalVisitedUrlEventTriggersCRUDActions';
import Actions from '../actions/actions';
import {
  SignalVisitedUrlEventTriggers,
  VisitedUrlEventTrigger,
} from '../model/SignalModel';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  entities: VisitedUrlEventTrigger[];
  entity: VisitedUrlEventTrigger;
};

const initialState: SignalVisitedUrlEventTriggers = {
  busy: false,
  visitedUrlEventTriggers: [],
};

export const signalVisitedUrlEventTriggers = (
  state = initialState,
  action: ActionType,
) => {
  switch (action.type) {
    case signalVisitedUrlEventTriggersCRUDActions.busyAction:
      return setBusy(state);

    case signalVisitedUrlEventTriggersCRUDActions.retrievedAllAction: {
      return {
        ...state,
        visitedUrlEventTriggers: action.entities,
        busy: false,
      };
    }
    case signalVisitedUrlEventTriggersCRUDActions.deleteLocalAction: {
      const { id } = action.entity;
      const entities = state.visitedUrlEventTriggers.filter(c => c.id !== id);
      return {
        ...state,
        busy: false,
        visitedUrlEventTriggers: entities,
      };
    }
    case signalVisitedUrlEventTriggersCRUDActions.retrievedAction: {
      const eventTrigger = action.entity;

      const { visitedUrlEventTriggers } = state;
      const index = visitedUrlEventTriggers.findIndex(
        p => p.id === eventTrigger.id,
      );
      const newVisitedUrlEventTriggers = Object.assign(
        [],
        visitedUrlEventTriggers.slice(),
        {
          [index === -1 ? visitedUrlEventTriggers.length : index]: eventTrigger,
        },
      );
      return {
        ...state,
        visitedUrlEventTriggers: newVisitedUrlEventTriggers,
        busy: false,
      };
    }
    case signalVisitedUrlEventTriggersCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
